<template>
<v-expansion-panel>
    <v-expansion-panel-header>{{$t('variantenauswahl')}}</v-expansion-panel-header>
    <v-expansion-panel-content>
        <template v-for="(item, index) in currentDoorConfiguration">
            <v-row :key="index">
                <v-col cols="8" class="py-1">
                    <div class="caption">{{ item.description }} {{item.code}}</div>
                </v-col>
                <v-col cols="4" class="py-1">
                    <div class="caption success--text">- {{ item.value.value }}</div>
                </v-col>
            </v-row>
        </template>
    </v-expansion-panel-content>
</v-expansion-panel>
    <!-- <div class="info-card">
        <div class="card-body dark-bg">
            <h4>Variantenauswahl</h4>
            <div class="card-element">
                <table class="table c-table">
                    <tbody>
                        <tr>
                            <td><h3>1. Hauptfunktion</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_HAUPTFUNKTION').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>2. Anwendung</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_ANWENDUNG').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>3. Werkstoff Tür</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_WERKSTOFF').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>4. Werkstoff Zarge</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_ZARGEN_WERKSTOFF').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>5. Bauform</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_OEFFNUNGSART').value.value }} {{ selectedValue('KTU_MM_KOMBI_ST_OL').value.value !== ''  ? ' / ' + selectedValue('KTU_MM_KOMBI_ST_OL').value.value : '' }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>6. Einbruchschutz</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_RC').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>7. Brandschutz</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_BH').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>8. Rauchschutz</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_RH').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>9. Wärmeschutz</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_WS').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>10. Schallschutz</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_S').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>11. Klimaklasse</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_KK').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>12. Türblattdicke</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_TUERBLATT_DICKE').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>13. Hochsicherheitstür</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FUNKTION_VSOE').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>14. Paniktür EN1125</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_PANIK').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>15. Fluchttür EN179</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_FLUCHT').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>16. Modellreihe</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('CUST_MM_MODELLREIHE').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>17. Modelle</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_MODELL').value.value }}</span></h3></td>
                        </tr>
                        <tr>
                            <td><h3>18. Artikelnummer</h3></td>
                            <td><h3><span>{{ ' - ' + selectedValue('KTU_MM_ARTIKELNR').value.value }}</span></h3></td>
                        </tr>                        
                    </tbody>
                </table>
            </div>
        </div>
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import * as $ from 'jquery';
    import { mapGetters } from 'vuex';
    import { DoorConfiguration } from '../../../configurator/DoorConfiguration';
    export default Vue.extend({
       name: 'RModelSelection',
       data: () => ({
        //    items: []
       }),
       computed: {            
            ...mapGetters('modelSelectionModule', ['getModelSelection', 'getProductMatrix']),
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
            currentDoorConfiguration() {
                return this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.ModelSelection);
            },                    
        },
        methods: {
            currentArticleNumber() {
                return this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].GetCurrentDoorArticleNumber();
            },
            selectedValue(characteristicCode) {
                const selectedCharacteristics = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.ModelSelection);
                let characteristicValue = selectedCharacteristics.filter((x) => x.code === characteristicCode)[0];

                if(typeof characteristicValue === 'undefined') {
                    characteristicValue = {
                        description: '',
                        value: {
                            value: '',
                        }
                    }
                }
                return characteristicValue;
            },
        },
        // beforeMount() {
        //     this.items = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.ModelSelection);
            
        // }
    });
</script>

<style scoped>
.v-expansion-panel::before{
    box-shadow: none;
}
</style>